// extracted by mini-css-extract-plugin
module.exports =  {"btn":"NFFlLEd","icon":"Xt2B1_Q","open":"b_0vV4U"};